import React from 'react';
interface SectionTagProps {
  icon?: string;
  children: React.ReactNode;
  tone?: 'accent' | 'gray';
}
export function SectionTag({
  icon,
  children,
  tone = 'accent'
}: SectionTagProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs sm:text-sm font-semibold uppercase tracking-wider ${tone === 'accent' ? 'border-naranja/30 bg-naranja/10 text-naranja' : 'border-gris-claro bg-gris-claro/60 text-muted'}`} data-id="element-318" data-mp="3nntbys5m1n79">
      {icon && <span aria-hidden="true" data-id="element-319" data-mp="3sluv1d31dmiq">{icon}</span>}
      {children}
    </span>;
}